import { render, staticRenderFns } from "./CleanupResultDialog.vue?vue&type=template&id=6d9b52fc&"
import script from "./CleanupResultDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CleanupResultDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports